import type { Resource } from '../../';
export const product_details_contentBlocks_freeShipping_modal_paragraphTitle1: Resource = {"default":"FREE SHIPPING"};
